const META_FIELD_CONFIG = {
  namespace: 'custom',
  key: 'bamboo_gift',
  resource: 'shop'
};

// KAMPANYA KURALLARI
const CAMPAIGN_RULES = {
  allowMultipleGifts: false,      // Tek sepet = tek hediye
  requireAnyMandatoryProduct: true
};

class MetaFieldCampaignSystem {
  constructor() {
    this.isProcessing = false;
    this.cartPageWidget = null;
    this.drawerWidget = null;
    this.campaignWidget = null; // aktif widget referansı (uyumluluk için)
    this.collections = {};
    this.activeCollections = [];
    this.isCartDrawer = false;
    this.init();
  }

  async init() {
    console.log('🚀 Meta Field Kampanya Sistemi başlatılıyor...');
    console.log('🔍 Document readyState:', document.readyState);
    console.log('🔍 LazyLoading config:', window.lazySizesConfig);
    console.log('🔍 Window campaignMetaData:', window.campaignMetaData);
    
    try {
      // Meta field'dan kampanya verilerini yükle
      await this.loadCampaignData();
      console.log('📊 Kampanya verileri yüklendi:', this.collections);
      
      // Widget oluştur
      this.createCampaignWidget();
      this.bindEvents();
      
      // İlk kontrol - hemen çalıştır
      this.checkAllCampaigns();
      
    } catch (error) {
      console.error('❌ Kampanya sistemi başlatma hatası:', error);
      this.showError('Kampanya verileri yüklenemedi');
    }
  }


  async loadCampaignData() {
    try {
      let campaignData;
      
      console.log('🔍 Meta field veri kaynakları kontrol ediliyor...');
      
      // Yöntem 1: Window'dan al (Liquid'den expose edilmiş)
      if (window.campaignMetaData && Object.keys(window.campaignMetaData).length > 0) {
        campaignData = window.campaignMetaData;
        console.log('📥 Meta data window\'dan alındı:', campaignData);
      }
      // Yöntem 2: HTML element'inden al
      else if (document.querySelector('#campaign-meta-data')) {
        const metaElement = document.querySelector('#campaign-meta-data');
        const metaText = metaElement.textContent.trim();
        console.log('📄 HTML element içeriği:', metaText);
        
        if (metaText && metaText !== 'null' && metaText !== '{}') {
          campaignData = JSON.parse(metaText);
          console.log('📥 Meta data HTML\'den alındı:', campaignData);
        } else {
          throw new Error('HTML element boş veya null');
        }
      }
      // Yöntem 3: Shopify Admin API (eğer access token varsa)
      else if (window.shopifyAccessToken) {
        console.log('🔑 API ile meta field çekiliyor...');
        const response = await fetch(`/admin/api/2023-10/metafields.json?metafield[owner_resource]=shop&metafield[namespace]=${META_FIELD_CONFIG.namespace}&metafield[key]=${META_FIELD_CONFIG.key}`, {
          headers: {
            'X-Shopify-Access-Token': window.shopifyAccessToken
          }
        });
        const data = await response.json();
        campaignData = JSON.parse(data.metafield?.value || '{}');
        console.log('📥 Meta data API\'den alındı:', campaignData);
      }
      // Yöntem 4: Liquid template'den gelen veri
      else if (window.shop && window.shop.metafields && window.shop.metafields.custom && window.shop.metafields.custom.bamboo_gift) {
        campaignData = window.shop.metafields.custom.bamboo_gift;
        console.log('📥 Meta data shop object\'den alındı:', campaignData);
      }
      else {
        console.warn('⚠️ Hiçbir meta field kaynağı bulunamadı');
        console.log('🔍 Mevcut window objeleri:', Object.keys(window));
        console.log('🔍 Shop objesi:', window.shop);
        throw new Error('Kampanya meta verisi bulunamadı - Tüm kaynaklar kontrol edildi');
      }

      // Veri doğrulama
      if (!campaignData || Object.keys(campaignData).length === 0) {
        throw new Error('Meta field verisi boş');
      }

      console.log('🔍 Ham meta field verisi kontrol ediliyor:', campaignData);
      console.log('🔢 Toplam koleksiyon sayısı:', Object.keys(campaignData).length);

      // Meta field verisini işle
      this.collections = this.processCampaignData(campaignData);
      console.log('✅ İşlenmiş kampanya verileri:', this.collections);
      
      // Son kontrol - işlenmiş veri boş mu?
      if (!this.collections || Object.keys(this.collections).length === 0) {
        console.error('❌ İşlenmiş veriler boş! Raw data ile comparison:');
        console.log('Raw:', campaignData);
        console.log('Processed:', this.collections);
        throw new Error('Veri işleme başarısız');
      }
      
    } catch (error) {
      console.error('❌ Meta field yükleme hatası:', error);
      console.log('🔄 Varsayılan veriler kullanılıyor...');
      
      // Fallback: Varsayılan veriler (geliştirme aşamasında)
      this.collections = this.getDefaultCampaignData();
      console.log('📋 Varsayılan veriler yüklendi:', this.collections);
    }
  }

  processCampaignData(rawData) {
    const processedData = {};
    
    console.log('🔄 Raw meta field verisi işleniyor:', rawData);
    console.log('🔍 Raw data type:', typeof rawData);
    console.log('🔍 Raw data keys:', Object.keys(rawData));
    
    // Meta field'dan gelen JSON verisini işle
    Object.keys(rawData).forEach(collectionKey => {
      const collection = rawData[collectionKey];
      
      console.log(`📋 ${collectionKey} koleksiyonu işleniyor:`, collection);
      
      // Yeni dinamik hediye sistemi için giftRules kontrolü
      if (collection.giftRules) {
        processedData[collectionKey] = {
          name: collection.name,
          minimumAmount: collection.minimumAmount * 100, // TL'yi kuruşa çevir
          requiredProducts: collection.requiredProducts || [], // Array of variant IDs
          eligibleProducts: collection.eligibleProducts || [], // Array of variant IDs  
          giftRules: collection.giftRules, // Dinamik hediye kuralları
          giftName: collection.giftName,
          giftValue: collection.giftValue,
          color: collection.color || '#667eea',
          active: collection.active !== false // Varsayılan olarak aktif
        };
      } else {
        // Eski sistem için geriye uyumluluk
        processedData[collectionKey] = {
          name: collection.name,
          minimumAmount: collection.minimumAmount * 100, // TL'yi kuruşa çevir
          requiredProducts: collection.requiredProducts || [], // Array of variant IDs
          eligibleProducts: collection.eligibleProducts || [], // Array of variant IDs  
          freeProduct: collection.freeProduct, // Ücretsiz variant ID
          giftName: collection.giftName,
          giftValue: collection.giftValue,
          color: collection.color || '#667eea',
          active: collection.active !== false // Varsayılan olarak aktif
        };
      }
      
      console.log(`✅ ${collectionKey} işlendi:`, processedData[collectionKey]);
    });

    console.log('🎯 Tüm işlenmiş veriler:', processedData);
    return processedData;
  }

  getDefaultCampaignData() {
    // Geliştirme aşamasında kullanılacak varsayılan veri
    console.log('⚠️ Varsayılan kampanya verileri kullanılıyor');
    
    return {
      DUO: {
        name: "Duo Koleksiyonu",
        minimumAmount: 4000000, // 40.000₺
        requiredProducts: [45734213615837, 45734213648605, 45734224330973, 45734224363741], // 4 zorunlu ürün, en az 1 tanesi yeterli
        eligibleProducts: [32450706211005, 38130027167933, 32450710569149, 45734213615837, 45734213648605, 45734224330973, 45734224363741, 32450709749949, 32450709848253, 32450714206397, 32450713125053],
        giftRules: {
          45734213615837: 46625540702429, // Bu ürün sepette varsa bu hediye
          45734213648605: 46625540735197, // Bu ürün sepette varsa bu hediye
          45734224330973: 46625540702429, // Bu ürün sepette varsa bu hediye
          45734224363741: 46625540735197, // Bu ürün sepette varsa bu hediye
          46612941897949: 46625540604125  // Bu ürün sepette varsa bu hediye
        },
        giftName: "Bamboo Yatak",
        giftValue: "6.500₺",
        color: "#667eea",
        active: true
      }
    };
  }

  bindEvents() {
    // Sepet değişiklik event'leri
    const events = [
      'DOMContentLoaded',
      'change', 
      'cart:updated',
      'shopify:section:load'
    ];

    events.forEach(event => {
      document.addEventListener(event, (e) => {
        if (event === 'change' && !e.target.matches('[name*="updates"], [name*="quantity"], input[type="number"]')) {
          return;
        }
        setTimeout(() => this.checkAllCampaigns(), 300);
      });
    });

    // Form submit'ler
    document.addEventListener('submit', (e) => {
      if (e.target.matches('[action*="/cart"]')) {
        setTimeout(() => this.checkAllCampaigns(), 800);
      }
    });

    // CartJS support
    if (typeof CartJS !== 'undefined') {
      CartJS.subscribe('cart.requestComplete', () => {
        this.checkAllCampaigns();
      });
    }

    // Tema QtySelector override'ı
    this.overrideThemeQtySelector();

    // Hediye ürün miktar artırma engelleme
    this.preventGiftQuantityIncrease();
  }

  preventGiftQuantityIncrease() {
    console.log('🚀 Hediye ürün koruma sistemi başlatılıyor...');
    
    // Güçlü hediye ürün kilitleme sistemi (eski versiyonun gücü ile)
    const lockAllGiftProducts = () => {
      // Cart page ve cart drawer için farklı selector'lar
      const cartSelectors = [
        '.cart__item',        // Cart page
        '.cart-drawer .cart__item', // Cart drawer
        '.drawer .cart__item'       // Drawer variant
      ];
      
      let allCartItems = [];
      cartSelectors.forEach(selector => {
        const items = document.querySelectorAll(selector);
        allCartItems = [...allCartItems, ...items];
      });
      
      let foundNewGifts = false;
      
      allCartItems.forEach((cartItem) => {
        // Zaten kilitli mi kontrol et ama daha agresif yeniden kilitle
        const isAlreadyLocked = cartItem.hasAttribute('data-gift-locked');
        
        // Hediye ürün olup olmadığını kontrol et
        if (this.isCartItemGift(cartItem)) {
          if (!isAlreadyLocked) {
            console.log('🎁 Yeni hediye ürün tespit edildi, kilitleniyor...');
            foundNewGifts = true;
          }
          
          // Her zaman kilitle (cart drawer için gerekli)
          this.lockGiftCartItem(cartItem);
          
          // Ekstra koruma: AJAX cart update'leri engelle
          this.blockGiftAjaxUpdates(cartItem);
        }
      });
      
      if (foundNewGifts) {
        console.log('✅ Hediye kilitleme işlemi tamamlandı');
      }
    };
    
    // İlk kontrol
    lockAllGiftProducts();
    
    // Çok agresif event listening (cart drawer için gerekli)
    const events = ['cart:updated', 'shopify:section:load', 'drawer:open', 'drawer:loaded'];
    events.forEach(event => {
      document.addEventListener(event, () => {
        setTimeout(lockAllGiftProducts, 100);
      });
    });
    
    // Global DOM izleme (cart drawer değişiklikleri için)
    const observer = new MutationObserver(() => {
      setTimeout(lockAllGiftProducts, 50);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'data-key']
    });
    
    // Çok agresif periyodik kontrol (cart drawer problemi için)
    setInterval(lockAllGiftProducts, 2000);
    
    // Theme QtySelector'ı tamamen override et
    this.overrideThemeQtySelector();
  }
  
  isCartItemGift(cartItem) {
    // Hediye ürün tespiti için çoklu yöntem
    
    // 1. Data attribute kontrolü
    if (cartItem.hasAttribute('data-gift-product')) {
      return true;
    }
    
    // 2. Variant ID ile kontrol
    const variantIdInput = cartItem.querySelector('input[name*="id"], input[data-variant-id]');
    if (variantIdInput) {
      const variantId = parseInt(variantIdInput.value);
      
      // Tüm koleksiyonlardaki hediye ürünleri kontrol et
      for (const collectionKey in this.collections) {
        const collection = this.collections[collectionKey];
        
        if (collection.giftRules) {
          const isGift = Object.values(collection.giftRules).includes(variantId);
          if (isGift) {
            return true;
          }
        } else if (collection.freeProduct === variantId) {
          return true;
        }
      }
    }
    
    // 3. Product title kontrolü (backup)
    const productTitle = cartItem.querySelector('.cart__product-name');
    if (productTitle && productTitle.textContent.toLowerCase().includes('hediye')) {
      return true;
    }
    
    return false;
  }
  
  lockGiftCartItem(cartItem) {
    // Cart item'ı işaretle (kilitlendiğini belirt)
    cartItem.setAttribute('data-gift-product', 'true');
    cartItem.setAttribute('data-gift-locked', 'true');
    
    // Quantity input'ları bul ve kilitle
    const quantityInputs = cartItem.querySelectorAll('input[type="number"], input[name*="quantity"], input[name*="updates"]');
    quantityInputs.forEach(input => {
      // Input'u kilitle
      input.value = '1';
      input.disabled = true;
      input.readOnly = true;
      input.setAttribute('min', '1');
      input.setAttribute('max', '1');
      input.setAttribute('data-gift-input', 'true');
      input.style.background = 'rgba(102, 126, 234, 0.1)';
      input.style.color = '#667eea';
      input.style.fontWeight = 'bold';
      
      // Input event'lerini engelle
      ['input', 'change', 'keydown', 'keyup', 'paste', 'focus'].forEach(eventType => {
        input.addEventListener(eventType, (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.value = '1';
          this.showNotification('warning', 'Hediye ürün miktarı değiştirilemez!');
          return false;
        }, { capture: true, passive: false });
      });
    });
    
    // Quantity butonlarını bul ve kilitle
    const quantityButtons = cartItem.querySelectorAll('.js-qty__adjust, .quantity__button, button[data-quantity-button]');
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.3';
      button.style.cursor = 'not-allowed';
      button.style.pointerEvents = 'none';
      button.setAttribute('tabindex', '-1');
      
      // Buton event'lerini engelle
      ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(eventType => {
        button.addEventListener(eventType, (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.showNotification('warning', 'Hediye ürün miktarı değiştirilemez!');
          return false;
        }, { capture: true, passive: false });
      });
    });
    
    // Quantity wrapper'ı kilitle ve hediye kutusu ekle
    const quantityWrapper = cartItem.querySelector('.js-qty__wrapper, .quantity');
    if (quantityWrapper) {
      quantityWrapper.style.pointerEvents = 'none';
      quantityWrapper.style.opacity = '0.7';
      quantityWrapper.setAttribute('data-gift-locked', 'true');
      quantityWrapper.style.position = 'relative';
      
      // Hediye kutusu ekle (quantity selector üzerinde)
      if (!quantityWrapper.querySelector('.gift-quantity-badge')) {
        const giftBadge = document.createElement('div');
        giftBadge.className = 'gift-quantity-badge';
        giftBadge.innerHTML = '🎁';
        giftBadge.style.cssText = `
          position: absolute;
          top: -10px;
          right: -10px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border-radius: 50%;
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          z-index: 15;
          box-shadow: 0 3px 8px rgba(102, 126, 234, 0.4);
          border: 2px solid white;
          animation: giftFloat 3s infinite ease-in-out;
        `;
        quantityWrapper.appendChild(giftBadge);
      }
    }
  }

  blockGiftAjaxUpdates(cartItem) {
    // AJAX cart update'leri engelle (cart drawer için kritik)
    const quantityInputs = cartItem.querySelectorAll('input[name*="updates"], input[name*="quantity"]');
    
    quantityInputs.forEach(input => {
      // Input'u sürekli 1'e sabitle
      input.value = '1';
      
      // Form submit event'leri engelle
      const form = input.closest('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          // Hediye ürün için quantity'yi zorla 1 yap
          if (this.isGiftProduct(input)) {
            input.value = '1';
            
            // Form data'yı manipüle et
            const formData = new FormData(form);
            formData.set(input.name, '1');
            
            console.log('🚫 Hediye ürün AJAX güncellemesi engellendi, quantity 1\'e sabitlendi');
          }
        }, { capture: true });
      }
      
      // AJAX quantity update'leri directment engelle
      input.addEventListener('change', (e) => {
        if (this.isGiftProduct(input)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.value = '1';
          
          // Backend'e doğru quantity'yi gönder
          this.forceCorrectQuantity(input);
          return false;
        }
      }, { capture: true, passive: false });
    });
  }

  async forceCorrectQuantity(input) {
    // Hediye ürün quantity'sini backend'de de düzelt
    const cartItem = input.closest('.cart__item');
    const variantKey = input.getAttribute('data-id') || input.name.match(/\[(.*?)\]/)?.[1];
    
    if (variantKey) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantKey,
            quantity: 1
          })
        });
        console.log('✅ Hediye ürün quantity backend\'de 1\'e sabitlendi');
      } catch (error) {
        console.error('❌ Backend quantity düzeltme hatası:', error);
      }
    }
  }

  preventQtySelectorEvents() {
    // QtySelector'ın event'lerini engelle - güçlendirilmiş versiyon
    const preventQtySelector = () => {
      const giftInputs = document.querySelectorAll('input[data-gift-input="true"]');
      
      giftInputs.forEach(input => {
        const wrapper = input.closest('.js-qty__wrapper');
        if (wrapper) {
          // Wrapper'ı devre dışı bırak
          wrapper.style.pointerEvents = 'none';
          wrapper.style.opacity = '0.5';
          wrapper.setAttribute('data-gift-locked', 'true');
          
          // QtySelector'ın event listener'larını kaldır
          const plusBtn = wrapper.querySelector('.js-qty__adjust--plus');
          const minusBtn = wrapper.querySelector('.js-qty__adjust--minus');
          
          if (plusBtn) {
            // Eski event listener'ları kaldır
            const newPlusBtn = plusBtn.cloneNode(true);
            plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
            
            // Butonu tamamen devre dışı bırak
            newPlusBtn.disabled = true;
            newPlusBtn.style.pointerEvents = 'none';
            newPlusBtn.style.cursor = 'not-allowed';
            newPlusBtn.setAttribute('tabindex', '-1');
            
            // Yeni event listener ekle (sadece engelleme)
            newPlusBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.showNotification('warning', 'Hediye ürün miktarı değiştirilemez!');
              return false;
            }, { capture: true, passive: false });
          }
          
          if (minusBtn) {
            // Eski event listener'ları kaldır
            const newMinusBtn = minusBtn.cloneNode(true);
            minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
            
            // Butonu tamamen devre dışı bırak
            newMinusBtn.disabled = true;
            newMinusBtn.style.pointerEvents = 'none';
            newMinusBtn.style.cursor = 'not-allowed';
            newMinusBtn.setAttribute('tabindex', '-1');
            
            // Yeni event listener ekle (sadece engelleme)
            newMinusBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              this.showNotification('warning', 'Hediye ürün miktarı değiştirilemez!');
              return false;
            }, { capture: true, passive: false });
          }
        }
      });
    };
    
    // Event listener'ları ekle
    document.addEventListener('DOMContentLoaded', preventQtySelector);
    document.addEventListener('cart:updated', preventQtySelector);
    document.addEventListener('shopify:section:load', preventQtySelector);
    
    // Periyodik kontrol ekle - tema QtySelector'ları yeniden initialize ettiğinde
    setInterval(preventQtySelector, 1000);
  }

  overrideThemeQtySelector() {
    // Theme.QtySelector'ı override et hediye ürünler için
    if (window.theme && window.theme.QtySelector) {
      const originalQtySelector = window.theme.QtySelector;
      const campaignSystem = this;
      
      window.theme.QtySelector = function(el, options) {
        // Hediye ürün kontrolü
        const input = el.querySelector('.js-qty__num');
        if (input && campaignSystem.isGiftProduct(input)) {
          console.log('🚫 Hediye ürün için QtySelector engellendi:', el);
          
          // Hediye ürün için özel davranış
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.5';
          el.setAttribute('data-gift-locked', 'true');
          
          // Butonları devre dışı bırak
          const plusBtn = el.querySelector('.js-qty__adjust--plus');
          const minusBtn = el.querySelector('.js-qty__adjust--minus');
          
          if (plusBtn) {
            plusBtn.disabled = true;
            plusBtn.style.pointerEvents = 'none';
            plusBtn.style.cursor = 'not-allowed';
          }
          
          if (minusBtn) {
            minusBtn.disabled = true;
            minusBtn.style.pointerEvents = 'none';
            minusBtn.style.cursor = 'not-allowed';
          }
          
          // Input'u kilitle
          input.disabled = true;
          input.readOnly = true;
          input.value = '1';
          
          return; // QtySelector initialize etme
        }
        
        // Normal ürünler için orijinal QtySelector'ı çalıştır
        return originalQtySelector.call(this, el, options);
      };
      
      // Orijinal prototype'ı koru
      window.theme.QtySelector.prototype = originalQtySelector.prototype;
      
      console.log('✅ Theme QtySelector override edildi');
    }
  }

  isGiftProduct(input) {
    // Input'un bağlı olduğu ürünün hediye olup olmadığını kontrol et
    const cartItem = input.closest('.cart__item, .cart-item, [data-cart-item]');
    if (!cartItem) return false;
    
    // Variant ID'yi bul
    const variantIdInput = cartItem.querySelector('input[name*="id"], input[data-variant-id]');
    if (!variantIdInput) return false;
    
    const variantId = parseInt(variantIdInput.value);
    
    // Tüm koleksiyonlardaki hediye ürünleri kontrol et
    for (const collectionKey in this.collections) {
      const collection = this.collections[collectionKey];
      
      if (collection.giftRules) {
        // Yeni dinamik sistem
        const isGift = Object.values(collection.giftRules).includes(variantId);
        if (isGift) return true;
      } else if (collection.freeProduct) {
        // Eski sistem için geriye uyumluluk
        if (variantId === collection.freeProduct) return true;
      }
    }
    
    return false;
  }

  createCampaignWidget() {
    // Cart page widget
    const cartPageEl = document.querySelector('#CartPageForm') || document.querySelector('.cart-page');
    if (cartPageEl && !this.cartPageWidget) {
      const widget = document.createElement('div');
      widget.id = 'meta-campaign-widget-page';
      widget.innerHTML = `
        <div class="meta-campaign-widget">
          <div class="campaign-gifts" style="display: none;">
            <div class="gifts-header">
              <span class="gifts-icon">🎁</span>
              <span class="gifts-title">Hediye Sepetinizde!</span>
            </div>
            <div class="gifts-list"></div>
          </div>
        </div>
      `;
      cartPageEl.insertBefore(widget, cartPageEl.firstChild);
      this.cartPageWidget = widget;
    }

    // Cart drawer widget
    const drawerEl = document.querySelector('#CartDrawer') || document.querySelector('#CartDrawerForm') || document.querySelector('.cart-drawer');
    if (drawerEl && !this.drawerWidget) {
      const widget = document.createElement('div');
      widget.id = 'meta-campaign-widget-drawer';
      widget.innerHTML = `
        <div class="meta-campaign-widget meta-campaign-widget--drawer">
          <div class="campaign-gift-drawer" style="display: none;"></div>
        </div>
      `;
      const footer = drawerEl.querySelector('.drawer__footer');
      if (footer) {
        footer.parentNode.insertBefore(widget, footer);
      } else {
        drawerEl.appendChild(widget);
      }
      this.drawerWidget = widget;
    }

    this.addWidgetStyles();
  }

  findCartElement() {
    // Cart page selector'ları
    const cartPageSelectors = ['#CartPageForm', '.cart-page'];
    // Cart drawer selector'ları
    const cartDrawerSelectors = ['#CartDrawer', '#CartDrawerForm', '.cart-drawer'];

    // Önce cart page kontrol et
    for (const selector of cartPageSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        this.isCartDrawer = false;
        console.log('🎯 Cart page bulundu:', selector);
        return element;
      }
    }

    // Sonra cart drawer kontrol et
    for (const selector of cartDrawerSelectors) {
      const element = document.querySelector(selector);
      if (element) {
        this.isCartDrawer = true;
        console.log('🎯 Cart drawer bulundu:', selector);
        return element;
      }
    }

    return null;
  }

  addWidgetStyles() {
    // Eski CSS'leri temizle
    const oldStyles = document.querySelector('#meta-campaign-styles');
    if (oldStyles) {
      oldStyles.remove();
      console.log('🗑️ Eski CSS temizlendi');
    }

    const styles = document.createElement('style');
    styles.id = 'meta-campaign-styles';
    styles.textContent = `
      /* CART DRAWER - SADE TEMA UYUMLU TASARIM */
      .drawer .meta-campaign-widget--drawer {
        background: transparent !important;
        border: none !important;
        padding: 6px 0 !important;
        margin: 6px 0 !important;
        font-family: brandon-grotesque !important;
        font-size: 12px !important;
        color: var(--colorDrawerText) !important;
        box-shadow: none !important;
        position: relative !important;
        line-height: 1.3 !important;
      }

      .drawer .campaign-gift-drawer {
        background: rgba(255, 255, 255, 0.06) !important;
        border: none !important;
        border-radius: 4px !important;
        padding: 8px 12px !important;
        display: flex !important;
        align-items: center !important;
        gap: 8px !important;
        font-family: brandon-grotesque !important;
      }

      .drawer .gift-icon {
        font-size: 14px !important;
        flex-shrink: 0 !important;
      }

      .drawer .gift-text {
        font-size: 11px !important;
        font-weight: 400 !important;
        color: var(--colorDrawerText) !important;
        flex: 1 !important;
        line-height: 1.3 !important;
        opacity: 0.9 !important;
      }

      .drawer .gift-value {
        font-size: 10px !important;
        opacity: 0.75 !important;
        color: var(--colorDrawerText) !important;
        font-weight: 500 !important;
        flex-shrink: 0 !important;
      }

      .drawer .gift-progress-mini {
        font-size: 10px !important;
        opacity: 0.75 !important;
        color: var(--colorDrawerText) !important;
        font-weight: 600 !important;
        flex-shrink: 0 !important;
      }

      /* MOBİL RESPONSIVE - CART DRAWER */
      @media only screen and (max-width: 589px) {
        .drawer .meta-campaign-widget--drawer {
          font-size: 11px !important;
          padding: 4px 0 !important;
          margin: 4px 0 !important;
        }

        .drawer .campaign-gift-drawer {
          padding: 6px 10px !important;
        }

        .drawer .gift-icon {
          font-size: 12px !important;
        }

        .drawer .gift-text {
          font-size: 10px !important;
        }

        .drawer .gift-value {
          font-size: 9px !important;
        }
      }

      /* CART PAGE - SADE TEMA UYUMLU TASARIM */
      .meta-campaign-widget {
        background: rgba(0, 0, 0, 0.03) !important;
        border: 1px solid rgba(0, 0, 0, 0.06) !important;
        border-radius: 4px !important;
        padding: 10px 14px !important;
        margin: 10px 0 !important;
        color: var(--colorTextBody) !important;
        font-family: brandon-grotesque !important;
        font-size: 12px !important;
        box-shadow: none !important;
        position: relative !important;
        overflow: visible !important;
      }

      .meta-campaign-widget:before {
        display: none !important;
      }

      .campaign-gifts {
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        border: none !important;
        border-radius: 0 !important;
        position: static !important;
        animation: none !important;
      }

      .gifts-header {
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
        margin: 0 !important;
      }

      .gifts-icon {
        font-size: 14px !important;
        animation: none !important;
      }

      .gifts-title {
        font-size: 12px !important;
        font-weight: 500 !important;
        font-family: brandon-grotesque !important;
        margin: 0 !important;
        color: var(--colorTextBody) !important;
        opacity: 0.9 !important;
      }

      .gifts-list {
        display: none !important;
      }

      /* RESPONSIVE - CART PAGE */
      @media only screen and (min-width: 590px) {
        .meta-campaign-widget {
          padding: 12px 16px !important;
          font-size: 13px !important;
        }

        .gifts-icon {
          font-size: 16px !important;
        }

        .gifts-title {
          font-size: 13px !important;
        }
      }

      @media only screen and (max-width: 589px) {
        .meta-campaign-widget {
          margin: 8px 0 !important;
          padding: 8px 12px !important;
          border-radius: 3px !important;
          font-size: 11px !important;
        }
        
        .gifts-icon {
          font-size: 12px !important;
        }

        .gifts-title {
          font-size: 11px !important;
        }
      }

      /* HEDİYE ÜRÜN STİLLERİ - Sadece quantity çerçevesi */

      /* Hediye ürün quantity input stilleri */
      input[disabled][data-gift-input="true"] {
        background: rgba(102, 126, 234, 0.1) !important;
        border-color: rgba(102, 126, 234, 0.3) !important;
        color: #667eea !important;
        cursor: not-allowed !important;
        opacity: 0.7 !important;
        pointer-events: none !important;
      }

      /* Hediye quantity wrapper stilleri - güçlendirilmiş */
      .js-qty__wrapper[data-gift-quantity="true"],
      .js-qty__wrapper[data-gift-locked="true"] {
        position: relative !important;
        opacity: 0.5 !important;
        pointer-events: none !important;
        user-select: none !important;
      }

      .js-qty__wrapper[data-gift-quantity="true"] .js-qty__adjust,
      .js-qty__wrapper[data-gift-locked="true"] .js-qty__adjust {
        opacity: 0.3 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
        background: #f5f5f5 !important;
        border-color: #ccc !important;
        color: #999 !important;
      }

      /* Hediye ürün tüm interaktif elementleri devre dışı */
      [data-gift-product="true"] input,
      [data-gift-product="true"] button,
      [data-gift-product="true"] select {
        pointer-events: none !important;
        opacity: 0.6 !important;
        cursor: not-allowed !important;
      }

      /* Hediye ürün quantity input özel stilleme */
      [data-gift-product="true"] input[type="number"] {
        background: rgba(102, 126, 234, 0.1) !important;
        border: 2px solid rgba(102, 126, 234, 0.3) !important;
        color: #667eea !important;
        font-weight: 600 !important;
        text-align: center !important;
      }

      /* Hediye etiketi - Quantity selector üzerinde şık tasarım */
      .gift-quantity-badge {
        position: absolute !important;
        top: -10px !important;
        right: -10px !important;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        color: white !important;
        border-radius: 50% !important;
        width: 22px !important;
        height: 22px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 11px !important;
        z-index: 15 !important;
        box-shadow: 0 3px 8px rgba(102, 126, 234, 0.4) !important;
        border: 2px solid white !important;
        animation: giftFloat 3s infinite ease-in-out !important;
      }
      
      /* Hediye kutusunun float animasyonu */
      @keyframes giftFloat {
        0%, 100% { 
          transform: translateY(0px) scale(1);
          box-shadow: 0 3px 8px rgba(102, 126, 234, 0.4);
        }
        50% { 
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 5px 12px rgba(102, 126, 234, 0.6);
        }
      }
      
      /* Hediye ürün quantity wrapper şık çerçevesi */
      .js-qty__wrapper[data-gift-locked="true"] {
        background: rgba(102, 126, 234, 0.08) !important;
        border: 2px solid #667eea !important;
        border-radius: 6px !important;
        padding: 4px !important;
        box-shadow: 0 0 8px rgba(102, 126, 234, 0.3) !important;
        position: relative !important;
        overflow: visible !important;
      }
      
      /* Quantity wrapper hover efekti */
      .js-qty__wrapper[data-gift-locked="true"]:hover {
        box-shadow: 0 0 12px rgba(102, 126, 234, 0.5) !important;
        transform: translateY(-1px) !important;
        transition: all 0.3s ease !important;
      }

      /* Hediye uyarı mesajı */
      .gift-warning {
        font-size: 10px !important;
        color: #667eea !important;
        margin-top: 2px !important;
        font-style: italic !important;
        font-weight: 500 !important;
      }
    `;

    document.head.appendChild(styles);
    console.log('✅ Sade tema uyumlu CSS yüklendi');
  }

  // Diğer metodlar aynı kalacak...
  async checkAllCampaigns() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      const cart = await this.getCart();
      const analysis = this.analyzeAllCollections(cart);

      console.log('📊 Meta Field Kampanya Analizi:', analysis);

      // Widget'ları kontrol et — yoksa veya DOM'dan kaldırılmışsa yeniden oluştur
      if ((!this.cartPageWidget || !document.contains(this.cartPageWidget)) &&
          (!this.drawerWidget || !document.contains(this.drawerWidget))) {
        this.cartPageWidget = null;
        this.drawerWidget = null;
        this.createCampaignWidget();
      }

      // Widget'ı güncelle
      this.updateWidget(analysis);
      
      // Hediye ürünleri yönet
      await this.manageGiftProducts(analysis);
      
      // Hediye ürün miktarlarını kontrol et ve düzelt
      this.enforceGiftQuantityLimit();
      
    } catch (error) {
      console.error('❌ Kampanya kontrol hatası:', error);
      this.showError('Kampanya kontrolü başarısız');
    } finally {
      this.isProcessing = false;
    }
  }

  async enforceGiftQuantityLimit() {
    // Hediye ürünlerin miktarını hem frontend hem backend'de 1'e sabitle
    const cart = document.querySelectorAll('#CartPageForm, .cart, .cart-drawer, [data-cart]');
    
    // Backend'deki quantity'leri de kontrol et
    try {
      const cartData = await fetch('/cart.js').then(r => r.json());
      const giftUpdates = {};
      
      cartData.items.forEach(item => {
        // Bu item hediye mi kontrol et
        const isGift = this.isItemGiftFromBackend(item);
        if (isGift && item.quantity > 1) {
          giftUpdates[item.key] = 1;
          console.log(`🔧 Backend'de hediye ürün quantity düzeltiliyor: ${item.product_title} (${item.quantity} → 1)`);
        }
      });
      
      // Backend'deki quantity'leri düzelt
      if (Object.keys(giftUpdates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: giftUpdates })
        });
        console.log('✅ Backend hediye ürün quantity\'leri düzeltildi');
      }
    } catch (error) {
      console.error('❌ Backend quantity kontrol hatası:', error);
    }
    
    // Frontend kontrolü
    cart.forEach(cartContainer => {
      const quantityInputs = cartContainer.querySelectorAll('input[name*="updates"], input[name*="quantity"], input[type="number"]');
      
      quantityInputs.forEach(input => {
        const cartItem = input.closest('.cart__item, .cart-item, [data-cart-item]');
        if (!cartItem) return;
        
        const isGiftProduct = this.isGiftProduct(input);
        
        if (isGiftProduct) {
          // Input değerini 1'e sabitle
          input.value = '1';
          input.disabled = true;
          input.readOnly = true;
          input.setAttribute('min', '1');
          input.setAttribute('max', '1');
          
          // Cart item'a hediye işareti ekle
          cartItem.setAttribute('data-gift-product', 'true');
          cartItem.setAttribute('data-gift-locked', 'true');
          input.setAttribute('data-gift-input', 'true');
          
          // Quantity wrapper'ı bul ve tamamen devre dışı bırak
          const quantityWrapper = input.closest('.quantity, .js-qty, .cart__qty, .js-qty__wrapper');
          if (quantityWrapper) {
            quantityWrapper.style.pointerEvents = 'none';
            quantityWrapper.style.opacity = '0.5';
            quantityWrapper.setAttribute('data-gift-locked', 'true');
            
            const quantityButtons = quantityWrapper.querySelectorAll('button[data-quantity-button], .quantity__button, .js-qty__btn, .js-qty__adjust');
            quantityButtons.forEach(button => {
              button.disabled = true;
              button.style.opacity = '0.3';
              button.style.cursor = 'not-allowed';
              button.style.pointerEvents = 'none';
              button.setAttribute('tabindex', '-1');
            });
          }
          
          // Kaldırma butonunu devre dışı bırak
          const removeButtons = cartItem.querySelectorAll('button[data-cart-remove], .cart__remove, .js-cart-remove, .cart__item-remove');
          removeButtons.forEach(button => {
            button.disabled = true;
            button.style.opacity = '0.5';
            button.style.cursor = 'not-allowed';
            button.style.pointerEvents = 'none';
          });
        }
      });
    });
  }

  isItemGiftFromBackend(item) {
    // Backend cart item'ından hediye tespiti
    if (item.properties && item.properties._free_gift === 'true') {
      return true;
    }
    
    // Variant ID ile kontrol
    for (const collectionKey in this.collections) {
      const collection = this.collections[collectionKey];
      
      if (collection.giftRules) {
        const isGift = Object.values(collection.giftRules).includes(item.variant_id);
        if (isGift) return true;
      } else if (collection.freeProduct === item.variant_id) {
        return true;
      }
    }
    
    return false;
  }

  preventGiftAjaxUpdates(input, cartItem) {
    // Form submit'leri engelle
    const forms = cartItem.querySelectorAll('form');
    forms.forEach(form => {
      // Yeni event listener ekle (capture fazında)
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.showNotification('warning', 'Hediye ürün değiştirilemez!');
        return false;
      }, { capture: true, passive: false });
    });
    
    // Input değişikliklerini izle ve engelle
    const handleInputChange = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.value = '1';
      this.showNotification('warning', 'Hediye ürün miktarı değiştirilemez!');
      return false;
    };
    
    // Tüm input eventleri için listener ekle
    ['input', 'change', 'keydown', 'keyup', 'paste'].forEach(eventType => {
      input.addEventListener(eventType, handleInputChange, { capture: true, passive: false });
    });
  }

  async getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Cart fetch failed');
    return await response.json();
  }

  analyzeAllCollections(cart) {
    const analysis = {
      collections: {},
      eligibleCollections: [],
      totalEligibleAmount: 0,
      hasGifts: false,
      activeGifts: []
    };

    // Adım 1: Aktif koleksiyonları topla
    const activeCollections = {};
    Object.keys(this.collections).forEach(collectionKey => {
      const collection = this.collections[collectionKey];
      if (collection.active) {
        activeCollections[collectionKey] = collection;
      }
    });

    // Adım 2: Her ürünü bir koleksiyona ata (eligible VEYA required)
    const assignedItems = {}; // { item.key: collectionKey }

    // Bir ürünün hangi koleksiyonlara ait olduğunu bul
    const getItemCollections = (item) => {
      return Object.keys(activeCollections).filter(key => {
        const col = activeCollections[key];
        return col.eligibleProducts.includes(item.variant_id) ||
               col.requiredProducts.includes(item.variant_id);
      });
    };

    // Hediye ürünü mü kontrol et
    const isGiftItem = (item) => {
      return Object.keys(this.collections).some(key => {
        const col = this.collections[key];
        return col.giftRules && Object.values(col.giftRules).includes(item.variant_id);
      });
    };

    // Önce tek koleksiyona ait ürünleri ata
    cart.items.forEach(item => {
      const isGift = isGiftItem(item);
      const belongsTo = getItemCollections(item);
      console.log('🔍 Ürün atama:', item.product_title, 'vid:', item.variant_id, 'isGift:', isGift, 'belongsTo:', belongsTo, 'key:', item.key);
      if (isGift) return;
      if (belongsTo.length === 1) {
        assignedItems[item.key] = belongsTo[0];
        console.log('✅ Atandı:', item.product_title, '->', belongsTo[0]);
      }
    });

    // Sonra ortak ürünleri hediyeye en yakın koleksiyona ata
    cart.items.forEach(item => {
      if (assignedItems[item.key] || isGiftItem(item)) return;
      const belongsTo = getItemCollections(item);

      if (belongsTo.length > 1) {
        let bestCollection = belongsTo[0];
        let bestScore = -Infinity;

        belongsTo.forEach(key => {
          const currentTotal = cart.items
            .filter(i => assignedItems[i.key] === key)
            .reduce((sum, i) => sum + i.final_line_price, 0);
          const remaining = activeCollections[key].minimumAmount - currentTotal;
          const score = -remaining; // Hediyeye en yakın = en yüksek skor
          if (score > bestScore) {
            bestScore = score;
            bestCollection = key;
          }
        });

        assignedItems[item.key] = bestCollection;
      }
    });

    console.log('📋 Atanmış ürünler:', JSON.stringify(assignedItems));

    // Adım 3: Her koleksiyonu atanmış ürünlerle analiz et
    Object.keys(this.collections).forEach(collectionKey => {
      const collection = this.collections[collectionKey];
      if (!collection.active) return;

      const collectionItems = cart.items.filter(item => assignedItems[item.key] === collectionKey);
      analysis.collections[collectionKey] = this.analyzeCollectionWithItems(cart, collection, collectionKey, collectionItems);
    });

    // Adım 4: Uygun koleksiyonları bul
    analysis.eligibleCollections = Object.keys(analysis.collections).filter(key =>
      analysis.collections[key].isEligible
    );

    // Adım 5: Mevcut hediyeleri kontrol et
    cart.items.forEach(item => {
      Object.keys(this.collections).forEach(collectionKey => {
        const collection = this.collections[collectionKey];
        if (item.variant_id === collection.freeProduct ||
            (item.properties && item.properties._campaign_collection === collectionKey)) {
          analysis.hasGifts = true;
          analysis.activeGifts.push({
            collection: collectionKey,
            item: item
          });
        }
      });
    });

    return analysis;
  }

  analyzeCollection(cart, collection, collectionKey) {
    const analysis = {
      name: collection.name,
      isEligible: false,
      hasRequiredProducts: false,
      itemCount: 0,
      totalAmount: 0,
      eligibleItems: [],
      progressPercentage: 0,
      missingAmount: 0,
      missingProducts: [],
      hasGift: false,
      requiredProductsInCart: []
    };

    // Sepetteki ürünleri kontrol et
    cart.items.forEach(item => {
      // Bu koleksiyonun hediye ürünü mü? (giftRules'dan kontrol et)
      if (collection.giftRules) {
        const isGiftProduct = Object.values(collection.giftRules).includes(item.variant_id);
        if (isGiftProduct) {
          analysis.hasGift = true;
          return;
        }
      } else if (item.variant_id === collection.freeProduct) {
        // Eski sistem için geriye uyumluluk
        analysis.hasGift = true;
        return;
      }

      // Bu koleksiyonun ürünü mü?
      if (collection.eligibleProducts.includes(item.variant_id)) {
        analysis.itemCount++;
        analysis.eligibleItems.push(item);
        analysis.totalAmount += item.final_line_price;
      }

      // Zorunlu ürün mü?
      if (collection.requiredProducts.includes(item.variant_id)) {
        analysis.requiredProductsInCart.push(item.variant_id);
      }
    });

    // EN AZ 1 TANE zorunlu ürün kontrolü
    analysis.hasRequiredProducts = analysis.requiredProductsInCart.length > 0;
    
    if (!analysis.hasRequiredProducts) {
      analysis.missingProducts = collection.requiredProducts; // Tüm zorunlu ürünleri göster
    }

    // Progress hesaplama
    analysis.progressPercentage = Math.min((analysis.totalAmount / collection.minimumAmount) * 100, 100);
    analysis.missingAmount = Math.max(collection.minimumAmount - analysis.totalAmount, 0);

    // Uygunluk kontrolü
    analysis.isEligible = 
      analysis.hasRequiredProducts && 
      analysis.totalAmount >= collection.minimumAmount &&
      analysis.itemCount > 0;

    return analysis;
  }

  analyzeCollectionWithItems(cart, collection, collectionKey, assignedItems) {
    const analysis = {
      name: collection.name,
      isEligible: false,
      hasRequiredProducts: false,
      itemCount: 0,
      totalAmount: 0,
      eligibleItems: [],
      progressPercentage: 0,
      missingAmount: 0,
      missingProducts: [],
      hasGift: false,
      requiredProductsInCart: []
    };

    // Hediye kontrolü (tüm sepetten)
    cart.items.forEach(item => {
      if (collection.giftRules) {
        if (Object.values(collection.giftRules).includes(item.variant_id)) {
          analysis.hasGift = true;
        }
      } else if (item.variant_id === collection.freeProduct) {
        analysis.hasGift = true;
      }
    });

    // Atanmış ürünlerle tutar hesapla
    assignedItems.forEach(item => {
      analysis.itemCount++;
      analysis.eligibleItems.push(item);
      analysis.totalAmount += item.final_line_price;

      if (collection.requiredProducts.includes(item.variant_id)) {
        analysis.requiredProductsInCart.push(item.variant_id);
      }
    });

    analysis.hasRequiredProducts = analysis.requiredProductsInCart.length > 0;
    if (!analysis.hasRequiredProducts) {
      analysis.missingProducts = collection.requiredProducts;
    }

    analysis.progressPercentage = Math.min((analysis.totalAmount / collection.minimumAmount) * 100, 100);
    analysis.missingAmount = Math.max(collection.minimumAmount - analysis.totalAmount, 0);

    analysis.isEligible =
      analysis.hasRequiredProducts &&
      analysis.totalAmount >= collection.minimumAmount &&
      analysis.itemCount > 0;

    return analysis;
  }

  updateWidget(analysis) {
    // Cart page widget güncelle
    if (this.cartPageWidget) {
      this.updateCartPageWidget(analysis);
    }
    // Drawer widget güncelle
    if (this.drawerWidget) {
      this.updateDrawerWidget(analysis);
    }
  }

  updateCartPageWidget(analysis) {
    const widget = this.cartPageWidget;
    const giftsSection = widget.querySelector('.campaign-gifts');
    if (!giftsSection) return;

    const giftsHeader = giftsSection.querySelector('.gifts-header');
    const giftsList = giftsSection.querySelector('.gifts-list');

    // 1. Hediye kazanıldıysa
    if (analysis.activeGifts.length > 0) {
      widget.style.display = 'block';
      if (giftsHeader) giftsHeader.innerHTML = '<span class="gifts-icon">🎁</span><span class="gifts-title">Hediye Sepetinizde!</span>';
      this.updateGiftsSection(analysis.activeGifts, giftsSection);
      giftsSection.style.display = 'block';
      return;
    }

    // 2. Zorunlu ürün var, tutara ulaşılmadı
    const nearestCollection = this.findNearestEligibleCollection(analysis);
    if (nearestCollection && giftsList) {
      widget.style.display = 'block';
      const { collectionKey, collectionAnalysis } = nearestCollection;
      const collection = this.collections[collectionKey];
      const missingFormatted = this.formatPrice(collectionAnalysis.missingAmount);

      if (giftsHeader) giftsHeader.innerHTML = '<span class="gifts-icon">🎁</span><span class="gifts-title">Kampanya</span>';
      giftsList.innerHTML = `
        <div class="gift-item" style="justify-content: center; text-align: center;">
          <span class="gift-emoji">🎁</span>
          <span>${collection.giftName} hediyesi için <strong>${missingFormatted}</strong> kaldı!</span>
        </div>
      `;
      giftsSection.style.display = 'block';
      return;
    }

    // 3. Kampanya ürünü var ama zorunlu ürün yok
    const collectionWithItems = this.findCollectionWithItemsNoRequired(analysis);
    if (collectionWithItems && giftsList) {
      widget.style.display = 'block';
      const collection = this.collections[collectionWithItems];

      if (giftsHeader) giftsHeader.innerHTML = '<span class="gifts-icon">🎁</span><span class="gifts-title">Kampanya</span>';
      giftsList.innerHTML = `
        <div class="gift-item" style="justify-content: center; text-align: center;">
          <span class="gift-emoji">🎁</span>
          <span>Karyola veya Ranza ekle, <strong>${collection.giftName}</strong> hediye!</span>
        </div>
      `;
      giftsSection.style.display = 'block';
      return;
    }

    // 4. Hiçbir şey gösterme
    widget.style.display = 'none';
  }

  updateDrawerWidget(analysis) {
    this.updateMinimalWidget(analysis, this.drawerWidget);
  }

  updateMinimalWidget(analysis, widget) {
    widget = widget || this.drawerWidget;
    if (!widget) return;
    const giftDrawer = widget.querySelector('.campaign-gift-drawer');
    if (!giftDrawer) return;

    // 1. Hediye kazanıldıysa göster
    if (analysis.activeGifts.length > 0) {
      widget.style.display = 'block';
      const gift = analysis.activeGifts[0];
      const collection = this.collections[gift.collection];

      giftDrawer.innerHTML = `
        <div class="gift-icon">🎁</div>
        <div class="gift-text">${collection.giftName} Hediye Sepette!</div>
        <div class="gift-value">${collection.giftValue}</div>
      `;
      giftDrawer.style.display = 'flex';
      return;
    }

    // 2. Zorunlu ürün var, tutara ulaşılmadı → "X₺ kaldı!"
    const nearestCollection = this.findNearestEligibleCollection(analysis);
    if (nearestCollection) {
      widget.style.display = 'block';
      const { collectionKey, collectionAnalysis } = nearestCollection;
      const collection = this.collections[collectionKey];
      const missingFormatted = this.formatPrice(collectionAnalysis.missingAmount);

      giftDrawer.innerHTML = `
        <div class="gift-icon">🎁</div>
        <div class="gift-text">${collection.giftName} hediyesi için ${missingFormatted} kaldı!</div>
        <div class="gift-progress-mini">%${Math.round(collectionAnalysis.progressPercentage)}</div>
      `;
      giftDrawer.style.display = 'flex';
      return;
    }

    // 3. Kampanya ürünü var ama zorunlu ürün yok → tavsiye göster
    const collectionWithItems = this.findCollectionWithItemsNoRequired(analysis);
    if (collectionWithItems) {
      widget.style.display = 'block';
      const collection = this.collections[collectionWithItems];

      giftDrawer.innerHTML = `
        <div class="gift-icon">🎁</div>
        <div class="gift-text">Karyola veya Ranza ekle, ${collection.giftName} hediye!</div>
      `;
      giftDrawer.style.display = 'flex';
      return;
    }

    // 4. Hiçbir şey gösterme
    widget.style.display = 'none';
  }

  updateGiftsSection(activeGifts, giftsSection) {
    const giftsList = giftsSection.querySelector('.gifts-list');
    giftsList.innerHTML = '';

    activeGifts.forEach(gift => {
      const collection = this.collections[gift.collection];
      const giftDiv = document.createElement('div');
      giftDiv.className = 'gift-item';
      giftDiv.innerHTML = `
        <div class="gift-info">
          <span class="gift-emoji">🎁</span>
          <div class="gift-details">
            <h4>${collection.giftName}</h4>
            <p>${collection.name}</p>
          </div>
        </div>
        <div class="gift-value">${collection.giftValue}</div>
      `;
      giftsList.appendChild(giftDiv);
    });
  }

  findNearestEligibleCollection(analysis) {
    // Zorunlu ürünü olan ama minimum tutara ulaşamamış en yakın koleksiyonu bul
    let nearest = null;
    let highestProgress = 0;

    Object.keys(analysis.collections).forEach(key => {
      const col = analysis.collections[key];
      if (col.hasRequiredProducts && !col.isEligible && col.progressPercentage > highestProgress) {
        highestProgress = col.progressPercentage;
        nearest = { collectionKey: key, collectionAnalysis: col };
      }
    });

    return nearest;
  }

  findCollectionWithItemsNoRequired(analysis) {
    // Eligible ürünü sepette olan ama zorunlu ürünü olmayan koleksiyonu bul
    for (const key of Object.keys(analysis.collections)) {
      const col = analysis.collections[key];
      if (col.itemCount > 0 && !col.hasRequiredProducts) {
        return key;
      }
    }
    return null;
  }

  formatPrice(amountInCents) {
    const tl = Math.ceil(amountInCents / 100);
    return tl.toLocaleString('tr-TR') + '₺';
  }

  async manageGiftProducts(analysis) {
    const cart = await this.getCart();

    // Sepette zaten herhangi bir kampanya hediyesi var mı?
    const existingGift = cart.items.find(item =>
      item.properties && item.properties._free_gift === 'true'
    );

    // Tek sepet = tek hediye. Hediye yoksa ve eligible koleksiyon varsa ekle.
    if (!existingGift && analysis.eligibleCollections.length > 0) {
      const collectionKey = analysis.eligibleCollections[0];
      const collection = this.collections[collectionKey];

      const requiredProductsInCart = cart.items.filter(item =>
        collection.requiredProducts.includes(item.variant_id)
      );

      if (collection.giftRules && requiredProductsInCart.length > 0) {
        const firstRequiredProduct = requiredProductsInCart[0];
        const giftProductId = collection.giftRules[firstRequiredProduct.variant_id];

        if (giftProductId) {
          await this.addGiftProduct(collection, collectionKey, giftProductId, firstRequiredProduct);
        }
      }
    }

    // Artık uygun olmayan hediyeleri kaldır
    for (const gift of analysis.activeGifts) {
      if (!this.shouldKeepGift(gift, analysis)) {
        await this.removeGiftProduct(gift.item);
      }
    }
  }

  shouldKeepGift(gift, analysis) {
    // Hediye ürününün hala uygun olup olmadığını kontrol et
    for (const collectionKey of analysis.eligibleCollections) {
      const collection = this.collections[collectionKey];
      if (collection.giftRules) {
        // Bu hediye ürününün hangi zorunlu ürün için verildiğini bul
        for (const [requiredProductId, giftProductId] of Object.entries(collection.giftRules)) {
          if (giftProductId === gift.item.variant_id) {
            // Bu zorunlu ürün hala sepette mi kontrol et
            const hasRequiredProduct = analysis.collections[collectionKey].requiredProductsInCart.includes(parseInt(requiredProductId));
            if (hasRequiredProduct) {
              return true; // Hediye kalmalı
            }
          }
        }
      }
    }
    return false; // Hediye kaldırılmalı
  }

  async addGiftProduct(collection, collectionKey, giftProductId, triggerItem) {
    try {
      console.log(`🎁 ${collection.name} hediyesi ekleniyor... (Ürün: ${giftProductId})`);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftProductId,
          quantity: 1,
          properties: {
            '_campaign_collection': collectionKey,
            '_gift_message': `${collection.name} Kampanya Hediyesi`,
            '_free_gift': 'true',
            '_trigger_product': triggerItem.variant_id.toString(),
            '_trigger_product_title': triggerItem.product_title
          }
        })
      });

      if (response.ok) {
        console.log(`✅ ${collection.name} hediyesi eklendi (Ürün: ${giftProductId})`);
        this.showNotification('success', `🎉 ${collection.giftName} hediye edildi!`);
        setTimeout(() => this.refreshCart(), 1000);
      }
    } catch (error) {
      console.error('❌ Hediye ekleme hatası:', error);
    }
  }

  async removeGiftProduct(item) {
    try {
      console.log('🗑️ Hediye ürün kaldırılıyor...');
      
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });

      console.log('✅ Hediye ürün kaldırıldı');
      setTimeout(() => this.refreshCart(), 500);
    } catch (error) {
      console.error('❌ Hediye kaldırma hatası:', error);
    }
  }

  refreshCart() {
    if (typeof refreshCart === 'function') {
      refreshCart();
    } else if (typeof updateCart === 'function') {
      updateCart();
    } else {
      window.location.reload();
    }
  }

  showNotification(type, message) {
    const existing = document.querySelector('.campaign-notification');
    if (existing) existing.remove();

    const notification = document.createElement('div');
    notification.className = `campaign-notification campaign-notification--${type}`;
    notification.innerHTML = `
      <div style="padding: 15px 20px; display: flex; justify-content: space-between; align-items: center;">
        <span>${message}</span>
        <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: white; font-size: 18px; cursor: pointer;">×</button>
      </div>
    `;

    const bgColor = type === 'success' ? '#28a745' : 
                   type === 'warning' ? '#ffc107' : 
                   type === 'error' ? '#dc3545' : '#007bff';

    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${bgColor};
      color: white;
      border-radius: 8px;
      z-index: 9999;
      animation: slideIn 0.3s ease;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      font-weight: 500;
      max-width: 300px;
    `;

    document.body.appendChild(notification);
    setTimeout(() => notification.remove(), 5000);
  }

  showError(message) {
    const errorSection = this.campaignWidget?.querySelector('.campaign-error');
    if (errorSection) {
      errorSection.style.display = 'block';
      const errorMessage = errorSection.querySelector('.error-message');
      if (errorMessage) {
        errorMessage.textContent = message;
      }
    }
  }
}

// Basitleştirilmiş sistem başlatma - Eski çalışan mantık
let metaCampaign;

// Basit ama etkili başlatma
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    console.log('🎯 DOMContentLoaded - Kampanya sistemi başlatılıyor...');
    metaCampaign = new MetaFieldCampaignSystem();
  });
} else {
  console.log('🎯 Document ready - Kampanya sistemi başlatılıyor...');
  metaCampaign = new MetaFieldCampaignSystem();
}

// Test fonksiyonları
window.testMetaCampaign = () => {
  if (metaCampaign) {
    console.log('Meta Field Kampanya Verileri:', metaCampaign.collections);
    return metaCampaign.checkAllCampaigns();
  }
};

// Hediye ürün kilitleme testi
window.testGiftLocking = () => {
  console.log('🧪 HEDİYE ÜRÜN KİLİTLEME TESTİ BAŞLATIYOR...');
  
  if (metaCampaign) {
    // Manual olarak hediye ürün kontrolü çalıştır
    metaCampaign.preventGiftQuantityIncrease();
    
    // Tüm cart item'ları kontrol et
    const cartItems = document.querySelectorAll('.cart__item');
    console.log(`📦 Toplam cart item: ${cartItems.length}`);
    
    cartItems.forEach((item, index) => {
      const quantityInputs = item.querySelectorAll('input[type="number"]');
      const isGift = metaCampaign.isCartItemGift(item);
      console.log(`Cart Item ${index + 1}:`, {
        element: item,
        isGift: isGift,
        quantityInputs: quantityInputs.length,
        disabled: quantityInputs[0]?.disabled,
        value: quantityInputs[0]?.value
      });
    });
  } else {
    console.log('❌ MetaCampaign sistemi henüz yüklenmedi!');
  }
};

// Anında hediye kilitleme
window.lockGiftsNow = () => {
  console.log('🔒 ANINDA HEDİYE KİLİTLEME...');
  
  if (metaCampaign) {
    const cartItems = document.querySelectorAll('.cart__item');
    console.log(`📦 Bulunan cart item sayısı: ${cartItems.length}`);
    
    cartItems.forEach((item, index) => {
      const isGift = metaCampaign.isCartItemGift(item);
      console.log(`Cart Item ${index + 1} - Hediye mi?: ${isGift}`);
      
      if (isGift) {
        metaCampaign.lockGiftCartItem(item);
        console.log('🔒 Hediye ürün kilitlendi:', item);
      }
    });
  }
};

// Hediye ürün test fonksiyonu
window.testGiftProducts = () => {
  if (metaCampaign) {
    console.log('🎁 Hediye ürün testi başlatılıyor...');
    
    // Tüm hediye ürünleri bul
    const giftInputs = document.querySelectorAll('input[data-gift-input="true"]');
    console.log('🔍 Bulunan hediye input sayısı:', giftInputs.length);
    
    giftInputs.forEach((input, index) => {
      const cartItem = input.closest('.cart-item, .cart__item, [data-cart-item]');
      console.log(`🎁 Hediye ${index + 1}:`, {
        input: input,
        cartItem: cartItem,
        disabled: input.disabled,
        readonly: input.readOnly,
        value: input.value,
        isGiftProduct: metaCampaign.isGiftProduct(input)
      });
    });
    
    // Quantity butonlarını test et
    const giftButtons = document.querySelectorAll('.js-qty__wrapper[data-gift-quantity="true"] .js-qty__adjust');
    console.log('🔘 Hediye quantity butonları:', giftButtons.length);
    
    giftButtons.forEach((button, index) => {
      console.log(`🔘 Buton ${index + 1}:`, {
        button: button,
        disabled: button.disabled,
        opacity: button.style.opacity,
        cursor: button.style.cursor
      });
    });
    
    return {
      giftInputs: giftInputs.length,
      giftButtons: giftButtons.length,
      collections: metaCampaign.collections
    };
  }
};

// Meta field yeniden yükleme fonksiyonu
window.reloadCampaignData = async () => {
  if (metaCampaign) {
    await metaCampaign.loadCampaignData();
    metaCampaign.checkAllCampaigns();
    console.log('✅ Kampanya verileri yeniden yüklendi');
  }
};

console.log('🎯 Meta Field Kampanya Sistemi hazır!');
console.log('📊 Kampanya verileri meta field\'dan çekiliyor');
console.log('🧪 Test: testMetaCampaign()');
console.log('🎁 Hediye Test: testGiftProducts()');
console.log('🔄 Yenile: reloadCampaignData()');
